import React from "react";
import FormationDesktopImg from "../assets/images/svg/formation-desktop-2025-2.svg";
import FormationMobileImg from "../assets/images/svg/formation-mobile-2025-2.svg";

const Formation = () => {
    return (
        <div id="formations" className="EmbedForm-area section-padding">
            <div className="container">
                <div className="text-center">
                    <div className="mini-title">Une formation parfaite pour changer de vie au gré de vos envies !</div>
                    <div className="column-title tw-max-w-3xl tw-mx-auto  tw-leading-tight">
                        Vatel propose <span className={'shape-bg'}>deux formations</span><br/>
                        en initial ou en alternance
                    </div>
                </div>
                <div className="pt-10">
                    <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
                        {/* Bachelor Card */}
                        <div
                            className="tw-bg-white tw-rounded-lg shadow-box tw-p-8">
                            <div className="tw-flex tw-items-center tw-mb-6">
                                <div
                                    className="tw-h-16 tw-w-16 tw-bg-primary tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                    <span className="tw-text-2xl tw-text-white">1</span>
                                </div>
                                <h3 className="tw-text-4xl tw-font-bold tw-ml-4">Bachelor</h3>
                            </div>

                            <div className="tw-space-y-4">
                                <h4 className="tw-text-lg tw-font-semibold">
                                    Responsable en management opérationnel en hôtellerie internationale
                                </h4>
                                <p className="tw-text-gray-600">
                                    European Bachelor of Management in Hospitality & Tourism
                                </p>
                            </div>
                        </div>
                        {/* MBA Card */}
                        <div
                            className="tw-bg-white tw-rounded-lg shadow-box tw-p-8">
                            <div className="tw-flex tw-items-center tw-mb-6">
                                <div
                                    className="tw-h-16 tw-w-16 tw-bg-[#b3901d] tw-rounded-full tw-flex tw-items-center tw-justify-center">
                                    <span className="tw-text-2xl tw-text-white">2</span>
                                </div>
                                <h3 className="tw-text-4xl tw-font-bold tw-ml-4">MBA</h3>
                            </div>

                            <div className="tw-space-y-4">
                                <h4 className="tw-text-lg tw-font-semibold">
                                    Directeur d'Hôtellerie Internationale
                                </h4>
                                <p className="tw-text-gray-600">
                                    European MBA in Hotel & Tourism
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="hidden md:block mt-12">
                        <img src={FormationDesktopImg}
                             alt="Une formation parfaite pour changer de vie au gré de vos envies !"/>
                    </div>
                    <div className="block md:hidden mt-12">
                        <img src={FormationMobileImg}
                             alt="Une formation parfaite pour changer de vie au gré de vos envies !"/>
                    </div>
                    <div className="text-center mt-12">
                        <small>Bachelor : (1) Titre niveau 6 inscrit au RNCP. (2) Diplôme Eurhodip niveau EQF 6<br/>
                            MBA : (1) Titre niveau 7 inscrit au RNCP. (2) Diplôme Eurhodip niveau EQF 7</small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Formation;
